"use strict";

import React from 'react';
import Card from "./Card";
import {useHistory} from "react-router-dom";

const AccountSettingBillingCard = ({address={}}) => {
    const history = useHistory();
    const attention = `${address.f_name || ''} ${address.l_name || ''}`;

    function handleEditClick(e){
        e.preventDefault();
        history.push('/echeck/accounts/settings/addresses/billing');
    }

    return (
        <Card title="Contact Information" onClick={handleEditClick} actionTitle="Edit Contact Settings" >
            <p className="echeck__card__text">{attention}</p>
            <p className="echeck__card__text">{address.address}</p>
        </Card>
    );
};

export default AccountSettingBillingCard;
